import { siteInfo } from '@/mocks/home';

const footerNavGroups = [
  {
    title: '内容导航',
    links: [
      { label: '焦点专题', href: '#carousel' },
      { label: '最新快讯', href: '#updates' },
      { label: '热门黑料', href: '#cards' },
      { label: '视频专区', href: '#media' },
      { label: '热度榜单', href: '#ranking' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '常见问答', href: '#faq' },
      { label: '平台优势', href: '#features' },
      { label: '联系投稿', href: '#contact' },
      { label: '移动端入口', href: '#app' },
    ],
  },
];

export default function Footer() {
  const handleAnchorClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-base text-white"></i>
              </span>
              <span className="font-heading text-lg font-bold">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              {siteInfo.description}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="w-2 h-2 rounded-full bg-green-400"></span>
              <span className="text-xs text-white/50">本站为唯一官方入口，谨防仿冒</span>
            </div>
          </div>

          {footerNavGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading font-bold text-sm md:text-base mb-4">
                {group.title}
              </h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleAnchorClick(link.href); }}
                      className="text-sm text-white/50 hover:text-white/80 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="font-heading font-bold text-sm md:text-base mb-4">
              合作伙伴
            </h3>
            <p className="text-sm text-white/30 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40 text-center sm:text-left">
              &copy; {new Date().getFullYear()} {siteInfo.name} · 本页为资讯聚合导航，内容仅供读者参考。
            </p>
            <div className="flex items-center gap-4 text-xs text-white/40">
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); handleAnchorClick('#hero'); }}
                className="hover:text-white/70 transition-colors cursor-pointer"
              >
                回到顶部 ↑
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}